import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { AppRoutes, PortalType } from '@sparrow-card/sparrow-card-constants';
import { QueryParams } from 'enums/QueryParams';
import { SourceIds } from 'enums/SourceIds';
import { setPortalType } from 'stores/application';

const SOURCE_ID_TO_PORTAL_TYPE_MAPPING: Partial<Record<SourceIds, PortalType>> = {
  [SourceIds.DirectMail]: PortalType.DirectMail,
  [SourceIds.Reinstatement]: PortalType.Reinstatement,
  [SourceIds.Starling]: PortalType.Starling,
};

const usePortalTypeWatcher = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (pathname.includes(AppRoutes.Reinstatement)) {
      dispatch(setPortalType(PortalType.Reinstatement));

      return;
    }

    if (pathname.includes(AppRoutes.Starling)) {
      dispatch(setPortalType(PortalType.Starling));

      return;
    }

    if (pathname.includes(AppRoutes.PreApproved)) {
      dispatch(setPortalType(PortalType.DirectMail));
    }

    if (pathname.includes(AppRoutes.Apply)) {
      const sourceId = searchParams.get(QueryParams.SourceID) as SourceIds;

      if (sourceId && sourceId in SOURCE_ID_TO_PORTAL_TYPE_MAPPING) {
        dispatch(setPortalType(SOURCE_ID_TO_PORTAL_TYPE_MAPPING[sourceId]!));
      } else {
        dispatch(setPortalType(PortalType.Standard));
      }
    }
  }, [pathname, dispatch, searchParams]);
};

export default usePortalTypeWatcher;
